import React from 'react';
import TableRow from '@material-ui/core/TableRow';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import Badge from '@material-ui/core/Badge';
import CheckIcon from '@material-ui/icons/Check';
import green from '@material-ui/core/colors/green';
import StyledTableCell from './StyledTableCell';
import ActionButtons from './ActionsButton';

import classes from './table.module.css';

const Row = ({ row, handleActive, updateRowAppointmentId }) => {
	return (
		<TableRow key={row.markingTeamId} className={classes.tableRow}>
			<StyledTableCell align="center">{row.qualificationYear}</StyledTableCell>
			<StyledTableCell align="left">{row.type}</StyledTableCell>
			<StyledTableCell align="left">{row.title}</StyledTableCell>
			<StyledTableCell align="left">{row.markingTeamCode}</StyledTableCell>
			<StyledTableCell>
				<FormControl className={classes.formControl}>
					<span id={`label_select_appointee_${row.markingTeamId}`}>Appointee</span>
					<Select
						labelId={`label_select_appointee_${row.markingTeamId}`}
						id={`select_appointee_${row.markingTeamId}`}
						value={row.appointmentId}
						onChange={e => updateRowAppointmentId(row, e.target.value)}
					>
						{row.appointees.map(x => {
							return (
								<MenuItem key={x.apptId} value={x.apptId}>
									{`${x.initials} ${x.surname}`}
								</MenuItem>
							);
						})}
					</Select>
				</FormControl>
			</StyledTableCell>
			<StyledTableCell component="th" scope="row" style={{ position: 'relative' }}>
				{row.isValidatedPreEx6 ? (
					<Badge
						badgeContent="Validated"
						style={{
							position: 'absolute',
							top: '10px',
							right: '25px',
							overflow: 'visible',
							margin: '0 0',
							color: 'green'
						}}
					>
						<CheckIcon
							title="Validated"
							style={{
								color: green[500]
							}}
						/>
					</Badge>
				) : null}
				<ActionButtons row={row} action={handleActive} />
			</StyledTableCell>
		</TableRow>
	);
};

export default Row;
